import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";

const Loading = (props) => {
  const isLoading = props.isLoading !== undefined ? props.isLoading : true;

  if (isLoading) {
    if (props.className === "load-spinner") {
      return <FontAwesomeIcon icon={faSpinner} spin />;
    }

    if (!props.className) {
      if (props.children != null) {
        return (
          <div className="loading-with-children">
            {props.children}
            <div
              className="loading-with-children__overlay items-container"
              style={props.styles}
              aria-busy="true"
              aria-live="polite"
            >
              <div className="circle" />
              <h1>{props.content || "Loading..."}</h1>
            </div>
          </div>
        );
      }
      return (
        <div className="items-container" style={props.styles}>
          <div className="circle" />
          <h1>{props.content || "Loading..."}</h1>
        </div>
      );
    }
  }

  return props?.children;
};

export default Loading;
